module.exports = __webpack_public_path__ + "static/requests-leaves-9612f272b289bad019544a99188d0c2c.png";